import axios from 'axios';

import * as utils from '../utils/utils.js';

export const queryAttendanceOverTime = async (startDate, endDate, events) => {
    var session_url = utils.backendUrl() + '/attendance-over-time';

    try {
        const response = await axios.post(
            session_url,
            {
                start_date: startDate,
                end_date: endDate,
                events: events,
                headers: {
                    'Content-Type': 'application/json',
                },
            },
            {
                withCredentials: true,
            }
        );

        return response.data.result;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const queryResponseStats = async (startDate, endDate, events) => {
    var session_url = utils.backendUrl() + '/attendance-response-stats';

    try {
        const response = await axios.post(
            session_url,
            {
                start_date: startDate,
                end_date: endDate,
                events: events,
                headers: {
                    'Content-Type': 'application/json',
                },
            },
            {
                withCredentials: true,
            }
        );

        return response.data.result;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

